module.exports = __webpack_public_path__ + "media/images/posts/wedding_food_art-9897b1329ceb797da0cc10d0ea4186c1.jpg";